/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["i.pendent[_ngcontent-%COMP%]{color:grey}i.acceptada[_ngcontent-%COMP%]{color:green}i.desestimada[_ngcontent-%COMP%]{color:red}i.denuncia[_ngcontent-%COMP%], i.pendent-validacio[_ngcontent-%COMP%]{color:orange}"];
export { styles as styles };
